const DetailsText = ({ children }: { children: string }) => {
  return (
    <div className="text-lg text-active font-nuinto italic">{children}</div>
  )
}

export default DetailsText